var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AxiosError } from 'axios';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import './wrapper/wrapper.scss';
import { FormContext, initialState, reducer } from '../../../common/context/context';
import Icons from '../../../icons';
import { ApiI18, getResponseErrorMessage } from '../../../network/api';
import { CenteredFlexContainer, InputContainer, RightAlignedComponent, SpaceBetweenContainer } from '../../../styles/generalStyles';
import { TitleForm } from '../../../styles/variables/text.styles';
import { Button } from '../../_common/button/button.styles';
import Input from '../../_common/input/input';
import { LangHelper } from '../../_common/lang/helper';
import LangMessage from '../../_common/lang/message';
import LangSwitcher from '../../_common/lang/switcher';
var ResetPassword = function (_a) {
    var handleFormChangeAnimate = _a.handleFormChangeAnimate;
    var _b = React.useReducer(reducer, initialState), state = _b[0], dispatch = _b[1];
    var _c = useParams(), code = _c.code, user = _c.user;
    var _d = useState(''), newPassword = _d[0], setNewPassword = _d[1];
    var _e = useState(''), confirmPassword = _e[0], setConfirmPassword = _e[1];
    var _f = useState(''), passwordError = _f[0], setPasswordError = _f[1];
    var _g = useState(''), passwordErrorAxios = _g[0], setPasswordErrorAxios = _g[1];
    var _h = useState(''), successResetPassword = _h[0], setSuccessResetPassword = _h[1];
    var handlePasswordChange = function (e) {
        setNewPassword(e.target.value);
        setPasswordError('');
        setPasswordErrorAxios('');
    };
    var handleConfirmPasswordChange = function (e) {
        setConfirmPassword(e.target.value);
        setPasswordError('');
        setPasswordErrorAxios('');
    };
    var handleSubmitNewPassword = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resetPassword, response, error_1, errText;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (newPassword !== confirmPassword) {
                        setPasswordError('CustDashboard.passwordsMustMatch');
                        return [2 /*return*/];
                    }
                    if (newPassword.length < 6) {
                        setPasswordError('CustDashboard.passwordsLeast6');
                        return [2 /*return*/];
                    }
                    if (!(newPassword === confirmPassword && newPassword.length > 5)) return [3 /*break*/, 5];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    resetPassword = {
                        code: code,
                        password: newPassword,
                        user: user,
                    };
                    return [4 /*yield*/, ApiI18.resetPassword(resetPassword)];
                case 2:
                    response = _c.sent();
                    if (response.status === 200) {
                        setNewPassword('');
                        setConfirmPassword('');
                        setPasswordErrorAxios('');
                        // setSuccessResetPassword('CustDashboard.yourPasswordHasBeenChangedSuccessfull')
                        setSuccessResetPassword(LangHelper.getLangMessageValue('CustDashboard.yourPasswordHasBeenChangedSuccessfully', state.lang));
                        // window.location.href = '/login';
                        setTimeout(function () {
                            window.location.href = '/login';
                        }, 3000);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _c.sent();
                    errText = LangHelper.getLangMessageValue('form.resetPassErr', state.lang);
                    if (error_1 instanceof AxiosError && ((_b = (_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message)) {
                        errText = getResponseErrorMessage(error_1);
                    }
                    setPasswordErrorAxios(errText);
                    setTimeout(function () {
                        window.location.href = '/login?forgotPassword';
                    }, 3000);
                    return [3 /*break*/, 4];
                case 4: return [3 /*break*/, 6];
                case 5:
                    setPasswordErrorAxios('Check it');
                    _c.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var HeaderStyles = {
        left: '20px',
        position: 'absolute',
        right: '20px',
        top: '20px',
        zIndex: 5,
    };
    return (_jsx(FormContext.Provider, __assign({ value: { dispatch: dispatch, state: state } }, { children: _jsxs(RightAlignedComponent, __assign({ width: '100%', style: { height: '100vh' } }, { children: [_jsxs(SpaceBetweenContainer, __assign({ style: HeaderStyles }, { children: [_jsx(LangSwitcher, {}), _jsxs(RightAlignedComponent, { children: [_jsx("a", __assign({ href: 'https://play.google.com/store/apps/details?id=tools.gad24.app&hl=de_CH', target: "_blank" }, { children: _jsx("img", { alt: 'google play', src: Icons.googlePlay, className: 'appButton' }) })), _jsx("a", __assign({ href: 'https://apps.apple.com/ch/app/gad24-app/id1510948466', target: "_blank" }, { children: _jsx("img", { alt: 'app store', src: Icons.appStore, className: 'appButton' }) }))] })] })), _jsxs("div", __assign({ style: { background: "white", paddingBottom: '40px', width: '470px', }, className: 'formWrapper' }, { children: [_jsx(CenteredFlexContainer, { children: _jsx("img", { className: "formLogo", alt: "logo", src: Icons.logoGA24 }) }), _jsxs("div", __assign({ style: { paddingTop: '40px' } }, { children: [_jsx(TitleForm, { children: _jsx(LangMessage, { msgKey: 'form.resetPassword', defaultValue: 'Reset Password' }) }), _jsx(InputContainer, { children: _jsx(Input, { placeholder: 'form.passwordStrength', type: "password", id: "password", name: "password", autoComplete: "new-password", value: newPassword, errorMessage: passwordError, errorMessageWithoutTrans: passwordErrorAxios, successMessage: successResetPassword, onChange: handlePasswordChange, handleClearInput: function () { setNewPassword(''); setPasswordError(''); setPasswordErrorAxios(''); } }) }), _jsx(InputContainer, { children: _jsx(Input, { placeholder: 'form.confirmPassword', type: "password", id: "confirmPassword", name: "confirmPassword", autoComplete: "new-password", value: confirmPassword, onChange: handleConfirmPasswordChange, handleClearInput: function () { return setConfirmPassword(''); } }) }), _jsx(CenteredFlexContainer, __assign({ "$paddingTop": '40px' }, { children: _jsx(Button, __assign({ "$bgColour": 'red', type: 'button', "$size": 'medium', onClick: function () { handleSubmitNewPassword(); handleFormChangeAnimate && handleFormChangeAnimate('login'); } }, { children: _jsx(LangMessage, { msgKey: 'form.submit', defaultValue: 'submit' }) })) }))] }))] }))] })) })));
};
export default ResetPassword;
